var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// @ts-ignore
import $ from 'jquery';
import { EventConstants } from "../../constants";
import Nanobus from "nanobus";
import { refreshColumn, switchColumnType } from "./ajax";
import { createElementFromString } from "../../helpers/elements";
import { fadeOut } from "../../helpers/animations";
import { uniqid } from "../../helpers/string";
var STATES = {
    CLOSED: 'closed',
    OPEN: 'open'
};
export var COLUMN_EVENTS = {
    REMOVE: 'remove',
    CLONE: 'clone',
};
var Column = /** @class */ (function () {
    function Column(element, name) {
        this.events = new Nanobus();
        this.name = name;
        this.element = element;
        this.state = STATES.CLOSED;
        this.setPropertiesByElement(element);
        this.init();
    }
    Column.prototype.setPropertiesByElement = function (element) {
        this.type = element.dataset.type;
        this.original = element.dataset.original === '1';
        this.disabled = element.classList.contains('disabled');
        element.dataset.columnName = this.name;
        return this;
    };
    Column.prototype.getName = function () {
        return this.name;
    };
    Column.prototype.getType = function () {
        return this.type;
    };
    Column.prototype.isOriginal = function () {
        return this.original;
    };
    Column.prototype.getElement = function () {
        return this.element;
    };
    Column.prototype.isDisabled = function () {
        return this.element.classList.contains('disabled');
    };
    Column.prototype.disable = function () {
        this.element.classList.add('disabled');
        return this;
    };
    Column.prototype.setLoading = function (enabled) {
        enabled
            ? this.getElement().classList.add('loading')
            : this.getElement().classList.remove('loading');
        return this;
    };
    Column.prototype.enable = function () {
        this.element.classList.remove('disabled');
        return this;
    };
    Column.prototype.init = function () {
        AdminColumns.events.emit(EventConstants.SETTINGS.COLUMN.INIT, this);
        return this;
    };
    Column.prototype.destroy = function () {
        this.element.remove();
    };
    Column.prototype.remove = function (duration) {
        var _this = this;
        if (duration === void 0) { duration = 350; }
        this.events.emit(COLUMN_EVENTS.REMOVE, this);
        fadeOut(this.getElement(), duration, function () {
            _this.destroy();
        });
    };
    Column.prototype.getState = function () {
        return this.state;
    };
    Column.prototype.toggle = function (duration) {
        if (duration === void 0) { duration = 150; }
        this.getState() === STATES.OPEN
            ? this.close(duration)
            : this.open(duration);
    };
    Column.prototype.close = function (duration) {
        if (duration === void 0) { duration = 0; }
        this.getElement().classList.remove('opened');
        $(this.getElement()).find('.ac-column-body').slideUp(duration);
        this.state = STATES.CLOSED;
    };
    Column.prototype.open = function (duration) {
        if (duration === void 0) { duration = 0; }
        this.getElement().classList.add('opened');
        $(this.getElement()).find('.ac-column-body').slideDown(duration);
        this.state = STATES.OPEN;
    };
    Column.prototype.isOpen = function () {
        return this.state === STATES.OPEN;
    };
    Column.prototype.showMessage = function (message) {
        var msgElement = this.getElement().querySelector('.ac-column-setting--type .msg');
        if (msgElement) {
            msgElement.innerHTML = message;
            msgElement.style.display = 'block';
        }
    };
    Column.prototype.getJson = function () {
        var e_1, _a;
        var formData = new FormData(this.getElement());
        formData.set('name', this.getName());
        var obj = {};
        try {
            // @ts-ignore
            for (var _b = __values(formData.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var entry = _c.value;
                var key = entry[0];
                var value = entry[1];
                if (this.fieldSupportsMultipleValues(key)) {
                    var _value = obj.hasOwnProperty(key) ? obj[key] : [];
                    _value.push(value);
                    obj[key] = _value;
                }
                else {
                    obj[key] = value;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return obj;
    };
    Column.prototype.switchToType = function (type) {
        var _this = this;
        this.setLoading(true);
        switchColumnType(type).then(function (response) {
            if (response.data.success) {
                var element = createElementFromString(response.data.data.trim()).firstChild;
                _this.name = uniqid();
                _this.reinitColumnFromElement(element);
            }
            else {
                _this.showMessage(response.data.data.error);
            }
        }).catch(function () {
            _this.showMessage(AC.i18n.errors.loading_column);
        }).finally(function () { return _this.setLoading(false); });
    };
    Column.prototype.refresh = function () {
        var _this = this;
        this.setLoading(true);
        refreshColumn(this.getName(), JSON.stringify(this.getJson())).then(function (response) {
            if (response.data.success) {
                _this.reinitColumnFromElement(createElementFromString(response.data.data.trim()).firstChild);
                AdminColumns.events.emit(EventConstants.SETTINGS.COLUMN.REFRESHED, _this);
            }
            else {
                _this.showMessage(AC.i18n.errors.loading_column);
            }
        }).finally(function () { return _this.setLoading(false); });
    };
    Column.prototype.fieldSupportsMultipleValues = function (key) {
        var element = this.getElement().elements[key];
        return (element && element.tagName === 'SELECT' && element.hasAttribute('multiple'));
    };
    Column.prototype.reinitColumnFromElement = function (element) {
        this.getElement().parentNode.replaceChild(element, this.getElement());
        this.element = element;
        this.setPropertiesByElement(element).init().open();
    };
    return Column;
}());
export { Column };
